<template>
  <div class="record-chart">
    <div class="record-table">
      <sirui-table
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :columns="columnList"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :showToolbar="false"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        height="350"
        show-footer
        :footer-method="footerMethod"
      >
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import { chartColumns } from './index.js';

  export default {
    name: 'InventoryRecordChart',
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      contractNo: {
        type: String,
        default: () => '',
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        // columnList: [],
        load: false,
        // contractNo:'',
      };
    },
    computed: {
      columnList() {
        return chartColumns();
      },
    },
    mounted() {
      // this.columnList = chartColumns;
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
    },
    methods: {
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['enterAmount'].includes(column.property)) {
              return data.reduce((cur, next) => cur + +next.enterAmount, 0).toFixed(2);
            }
            if (['toAmount'].includes(column.property)) {
              return data.reduce((cur, next) => cur + +next.toAmount, 0).toFixed(2);
            }
            return null;
          }),
        ];
      },
      fullTableData(tableData) {
        this.tableData = tableData;
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      // 获取表格数据
      // async getTableData(contractNo) {
      //   this.loading = true;
      //   let { data } = await this.$axios.post(`${API.QUERYINVENTORY}`, {
      //     contractNo: contractNo ? contractNo : this.contractNo,
      //     pageNum: this.$refs.siruiTable.page.pageNum,
      //     pageSize: this.$refs.siruiTable.page.pageSize,
      //   });
      //   this.loading = false;
      //   if (data.code == 0) {
      //     this.$refs.siruiTable.setPageTotal(data.data.total);
      //     this.tableData = data.data.list.map((item) => {
      //       return {
      //         ...item,
      //         toAmount: item.orderType == 'CK' ? item.weight : '',
      //         enterAmount: item.orderType == 'RK' ? item.weight : '',
      //       };
      //     });
      //     console.log('表格数据', this.tableData);
      //     // this.$nextTick(() => {
      //     //   this.$forceUpdate();
      //     // });
      //   } else {
      //     this.$message.error('查询表格数据失败');
      //     this.tableData = [];
      //   }
      // },
    },
    watch: {
      tableDataList: {
        handler(val) {
          if (val && Array.isArray(val) && val.length)
            this.tableData = val.map((item) => {
              return {
                ...item,
                toAmount: item.orderType == 'CK' ? item.weight : '',
                enterAmount: item.orderType == 'RK' ? item.weight : '',
                // 暂时将货物单位固定
                hwUnit: item.hwUnit ? '吨/件' : '',
              };
            });
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .record-chart {
    background: #fff;

    .record-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
